<template>
  <div class="upload">
    <div style="display: inherit" @click="handleClick">
      <slot>
        <div class="upload-text">{{ statusText }}</div>
      </slot>
      <input
        ref="input"
        class="upload-input"
        type="file"
        @change="fileChange"
        :accept="[!fileType ? '' : `${fileType.toLowerCase()}/*`]"
      />
    </div>
    <span
      v-if="uploading && showCacelBtn"
      class="upload-cancel"
      @click="cancelUpload"
      >取消上传</span
    >
  </div>
</template>

<script>
import {
  getAliyunUserId,
  getUploadVideoToken,
  refreshUploadVideo,
  upsertResource
} from '@/api/resource'

export default {
  name: 'AliyunUpload',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * 选择文件后，是否自动上传
     */
    autoUpload: {
      type: Boolean,
      default: true
    },
    uploadChannel: {
      type: Number,
      default: 1
    },
    authorId: {
      type: String
    },
    /**
     * 转码模板
     */
    temp: {
      type: String,
      default: null
    },
    /**
     * 文件格式限制，不转默认都支持
     */
    formats: {
      type: Array,
      default: null
    },
    /*
     * 文件类型限制：video、audio、image;默认不限
     */
    fileType: {
      type: String,
      default: null
    },
    showCacelBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      aliyunUserId: '',
      file: '',
      uploader: null,
      progress: 0,
      uploading: false,
      statusText: '上传文件',
      uploadTitle: ''
    }
  },
  created() {
    this.getAliyunUserId()
  },
  methods: {
    handleClick() {
      if (this.disabled) return

      if (this.uploading) {
        this.cancelUpload()
      } else {
        this.$refs.input.click()
      }
    },
    fileChange(e) {
      this.file = e.target.files[0]
      if (!this.file) {
        return
      }
      // 文件类型，video、audio、image
      if (this.fileType) {
        var type = this.file.type.split('/')[0]
        if (type !== this.fileType.toLowerCase()) {
          var msg = '视频'
          if (this.fileType.toLowerCase() === 'audio') {
            msg = '音频'
          } else if (this.fileType.toLowerCase() === 'image') {
            msg = '图片'
          }
          this.onError(`请上传【${msg}】类型的文件`)
          return false
        }
      }

      // 文件格式
      var sp = this.file.name.split('.')
      if (
        this.formats &&
        this.formats.length > 0 &&
        !this.formats.some(
          x => x.toUpperCase() === sp[sp.length - 1].toUpperCase()
        )
      ) {
        this.onError(`暂不支持【${sp[sp.length - 1].toUpperCase()}】格式的文件`)
        return false
      }

      const userData = '{"Vod":{}}'
      if (this.uploader) {
        this.progress = 0
        this.statusText = ''
      }

      this.uploader = this.createUploader()

      this.uploader.addFile(this.file, null, null, null, userData)

      if (this.autoUpload) {
        this.$emit('uploadFileChanged')
        this.startUpload()
      }
    },
    startUpload() {
      if (this.uploader !== null) {
        this.uploading = true
        this.uploader.startUpload()

        this.$emit('startUpload')
      }
    },
    cancelUpload() {
      if (this.uploader !== null) {
        this.uploader.stopUpload()
        this.uploading = false
        this.$refs.input.value = ''
      }
    },
    handleUploadFail(uploadInfo, code, message) {
      this.statusText = '上传文件'
      this.uploading = false
      this.$refs.input.value = ''
      this.uploader.deleteFile(0)

      this.$toasted.show('文件上传失败!', {
        position: 'bottom-center',
        duration: 3000
      })
    },
    createUploader() {
      const uploader = new window.AliyunUpload.Vod({
        timeout: 600000,
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: 'cn-shanghai',
        userId: this.aliyunUserId,
        // 添加文件成功
        addFileSuccess: uploadInfo => {
          console.log('[addFileSuccess]: ', uploadInfo)
          this.$emit('addFileSuccess', uploadInfo)
        },
        onUploadstarted: async uploadInfo => {
          this.$emit('uploadstarted', uploadInfo)
          console.log('[uploadstarted]: ', uploadInfo)

          this.statusText = '取消'
          console.log(
            '[onUploadStarted]:' +
              uploadInfo.file.name +
              ', endpoint:' +
              uploadInfo.endpoint +
              ', bucket:' +
              uploadInfo.bucket +
              ', object:' +
              uploadInfo.object
          )
          let videoTokenDetail
          this.uploadTitle = uploadInfo.file.name.replace(/\.[^.]+$/, '')
          if (!uploadInfo.videoId) {
            videoTokenDetail = await getUploadVideoToken({
              title: this.uploadTitle,
              fileName: uploadInfo.file.name,
              template: this.temp
            })

            this.uploader.setUploadAuthAndAddress(
              uploadInfo,
              videoTokenDetail.uploadAuth,
              videoTokenDetail.uploadAddress,
              videoTokenDetail.videoId
            )
          } else {
            videoTokenDetail = await refreshUploadVideo(uploadInfo.videoId)

            this.uploader.setUploadAuthAndAddress(
              uploadInfo,
              videoTokenDetail.uploadAuth,
              videoTokenDetail.uploadAddress
            )
          }

          window.uploader = uploader

          console.info('uploader:', uploader)
          console.info('checkPoint:', uploader.getCheckpoint(this.file))

          if (!videoTokenDetail) {
            console.log('刷新凭据异常')
            this.handleUploadFail()
          }
        },
        onUploadSucceed: async uploadInfo => {
          console.log('[onUploadSucceed]: ', uploadInfo)

          if (uploadInfo.state === 'Success') {
            // 调用后台资源库
            await this.upsertResource(uploadInfo)
            this.$emit('onUploadSucceed')
          }
        },
        // 文件上传失败
        onUploadFailed: (uploadInfo, code, message) => {
          this.$emit('progress', 0)
          this.$emit('uploadFailed', uploadInfo)
          this.statusText = '重新上传'

          this.handleUploadFail()

          console.log(
            'onUploadFailed: file:' +
              uploadInfo.file.name +
              ',code:' +
              code +
              ', message:' +
              message
          )
        },
        // 取消文件上传
        onUploadCanceled: (uploadInfo, code, message) => {
          this.$emit('progress', 0)
          this.$emit('uploadCanceled', uploadInfo)
          this.statusText = '重新上传'

          console.log(
            'Canceled file: ' +
              uploadInfo.file.name +
              ', code: ' +
              code +
              ', message:' +
              message
          )
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: (uploadInfo, totalSize, progress) => {
          if (progress) {
            progress = Math.round(progress * 100) / 100
          }

          this.$emit('uploadProgress', progress)

          console.log(
            'onUploadProgress:file:' +
              uploadInfo.file.name +
              ', fileSize:' +
              totalSize +
              ', percent:' +
              Math.ceil(progress * 100) +
              '%'
          )
        },
        onUploadTokenExpired: async uploadInfo => {
          console.info('onUploadTokenExpired: ', uploadInfo)

          const videoTokenDetail = await refreshUploadVideo(uploadInfo.videoId)
          uploader.resumeUploadWithAuth(videoTokenDetail.uploadAuth)
        },
        // 全部文件上传结束
        onUploadEnd: uploadInfo => {
          this.$emit('uploadEnd', uploadInfo)

          console.log('onUploadEnd: uploaded all the files')
        }
      })

      return uploader
    },
    /**
     * 获取阿里云用户id
     */
    async getAliyunUserId() {
      const localAliyunUserId = sessionStorage.getItem('aliyunUserId')
      if (localAliyunUserId) {
        this.aliyunUserId = localAliyunUserId
        return
      }

      const { result, detail } = await getAliyunUserId()

      if (result.code === 0) {
        this.aliyunUserId = detail
        sessionStorage.setItem('aliyunUserId', detail)
      }
    },
    /**
     * 视频上传成功后通知后台
     * @param info
     * @return {Promise<void>}
     */
    async upsertResource(info) {
      const { result, detail } = await upsertResource({
        MediaId: info.videoId,
        Type: 1,
        Channel: this.uploadChannel,
        Title: this.uploadTitle,
        AuthorId: this.authorId,
        Duration: 0,
        FileSize: info.file.size,
        PlayCount: info.videoInfo.vmCount,
        UploadedTime: info.file.lastModified
      })
      //
      if (result.code === 0) {
        const infoDetail = {
          mediaId: info.videoId,
          title: this.uploadTitle,
          fileName: info.file.name,
          uploadedTime: new Date(),
          id: detail.id
        }
        this.$emit('uploadComplete', infoDetail, detail)
        this.statusText = '重新上传'
      } else {
        this.$emit('progress', 0)
        this.$emit('uploadFailed', null)
        this.statusText = '重新上传'

        this.$toasted.show(result.msg, {
          position: 'bottom-center',
          duration: 3000
        })
      }

      this.uploading = false
    },
    onError(msg) {
      this.$emit('onError', msg)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  display: inline-block;
  cursor: pointer;
}

.upload-text {
  font-size: 12px;
  line-height: 40px;
  color: #046bcc;
}

.upload-input {
  display: none;
}
.upload-cancel {
  display: inline-flex;
  color: #046bcc;
  padding-left: 10px;
}
</style>
